module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("fCDO8"))).then(() => parcelRequire('4Lqeb'));